import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { fbPageView } from './fbpixel';

/**
 * Fires a Facebook Pixel `PageView` event on every SPA route change.
 * The initial PageView is fired by the base Pixel code in /public/index.html.
 */
const FBPageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // The base pixel code in index.html already fires PageView on first load.
    // Skip the very first render to avoid duplicate event on initial page.
    if (typeof window !== 'undefined') {
      if (!window.__fbPageViewInitDone) {
        window.__fbPageViewInitDone = true;
        return;
      }
      fbPageView();
    }
  }, [location.pathname, location.search]);

  return null;
};

export default FBPageViewTracker;
